import defaultColors from "../defaultColors";
import defaultAssets from "../defaultAssets";
const footerLinks = [{
  text: "shared.support",
  href: "#"
}, {
  text: "footer.terms",
  href: "#"
}, {
  text: "footer.privacy",
  href: "#"
}, {
  text: "shared.educhain",
  href: "#"
}];
const educhain = {
  name: "Blue theme (default)",
  value: "educhain",
  brand: "EduChain",
  website: "#",
  // TODO I should add this to less.json and convert between the two required formats
  colors: { ...defaultColors
  },
  footerLinks: footerLinks,
  verifyURL: "http://verify.example.com",
  phone: "+971 55 160 5623",
  email: "support@educhain.io",
  assets: { ...defaultAssets
  }
};
export { educhain };